import { Text, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { MODAL_CONTENT_SIZING, MODAL_SIZING } from "../../../utils/constants";
import { BenchmarkInput } from "../../../api/benchmark/benchmarkApi";
import { BenchmarkForm } from "./BenchmarkForm";

interface BenchmarkModalProps {
    show: boolean;
    onClose: () => void;
    rowData?: BenchmarkInput;
    onSave?: (data: BenchmarkInput) => void;
    clientId?: string;
}

export const BenchmarkModal: FunctionComponent<BenchmarkModalProps> = ({ show, onClose, rowData, clientId }) => {
    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...MODAL_CONTENT_SIZING }} overflowY="auto">
                <ModalHeader>{rowData ? "Edit Benchmark Input" : "Add Benchmark Input"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text as="ul" pl="1.5rem">
                        <Text as="li">All percentage fields should be filled out as percentage values (e.g., 50 for 50%), not decimals.</Text>
                        <Text as="li" mb="2rem">
                            If number/percentage fields are left blank, they will not be counted in final calculation.
                        </Text>
                    </Text>
                    <BenchmarkForm show={show} onClose={onClose} rowData={rowData} clientId={clientId} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
